import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

import Layout from 'components/common/Layout';
import ResetPasswordEmail from 'components/account/ResetPasswordEmail';
import ResetPasswordNavigation from 'components/account/ResetPasswordNavigation';
import AccountNavigation from 'components/account/AccountNavigation';
import AccountLogo from 'components/account/AccountLogo';

import { appTitle, titleSeparator } from 'config/helmetSettings';
import tidioSrc from 'config/tidioSrc';

class AccountResetPasswordEmail extends Component {
  componentDidMount() {
    const htmlEl = document.querySelector('html');
    htmlEl.classList.add('page-with-tidio');
  }

  componentWillUnmount() {
    const htmlEl = document.querySelector('html');
    htmlEl.classList.remove('page-with-tidio');
  }

  render() {
    return (
      <Layout variant="account-login">
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Password Reset
          </title>
          <script src={tidioSrc} async />
        </Helmet>
        <AccountLogo />
        <ResetPasswordEmail
          form="reset-password-email"
        />
        <ResetPasswordNavigation />
        <AccountNavigation />
      </Layout>
    );
  }
}

export default AccountResetPasswordEmail;



// WEBPACK FOOTER //
// ./src/pages/account/AccountResetPasswordEmail.js